import { Routes } from '@angular/router';
import { AuthGuard } from '@app/auth.guard';

export const APP_LAYOUT_ROUTES: Routes = [
    //Dashboard
    {
        path: 'dashboard',
        canActivateChild: [AuthGuard],
        data: { expectedRole: [] },
        loadChildren: () => import('../views/dashboard/dashboard.module').then(m => m.DashboardModule),
    },
    //Apps
    {
        path: 'apps',
        loadChildren: () => import('../views/apps/apps.module').then(m => m.AppsModule),
    },
    // UI Elements
    {
        path: 'ui-elements',
        loadChildren: () => import('../views/ui-elements/ui-elements.module').then(m => m.UiElementsModule),
    },
    // Icons 
    {
        path: 'icons',
        loadChildren: () => import('../views/icons/icons.module').then(m => m.IconsModule),
    },
    {
        path: 'maps',
        loadChildren: () => import('../views/maps/maps.module').then(m => m.MapsModule),
    },
    // Chart  
    {
        path: 'charts',
        loadChildren: () => import('../views/charts/charts.module').then(m => m.ChartsModule),
    },
    // Form Elements
    {
        path: 'form-elements',
        loadChildren: () => import('../views/form-elements/form-elements.module').then(m => m.FormElementsModule),
    },
    // Tables  
    {
        path: 'tables',
        loadChildren: () => import('../views/tables/tables.module').then(m => m.TablesModule),
    },
    // Pages  
    {
        path: 'pages',
        loadChildren: () => import('../views/pages/pages.module').then(m => m.PagesModule),
    },
    // Docs  
    {
        path: 'docs',
        loadChildren: () => import('../views/docs/docs.module').then(m => m.DocsModule),
    },
    {
        path:'inquiry/:name',
        canActivateChild: [AuthGuard],
        data: { expectedRole: [] },
        loadChildren: () => import('../views/inquiry-data/inquiry-data.module').then(m=>m.InquiryDataModule)
    },
    {
        path:'addUser',
        canActivateChild: [AuthGuard],
        data: {expectedRole: ['Employee','Developer']},
        loadChildren: ()=> import('../views/new-user/new-user.module').then(m=>m.NewUserModule)
    },
    {
        path:'addProject',
        canActivateChild: [AuthGuard],
        data: {expectedRole: ['Admin','Employee', 'Developer']},
        loadChildren: ()=> import('../views/add-project/add-project.module').then(m=>m.AddProjectModule)
    },
    {
        path:'editProject/:id',
        canActivateChild: [AuthGuard],
        data: {expectedRole: ['Admin','Employee', 'Developer']},
        loadChildren: ()=> import('../views/add-project/add-project.module').then(m=>m.AddProjectModule)
    },
    {
        path:'projects',
        canActivateChild: [AuthGuard],
        data: {expectedRole: ['Admin','Employee', 'Developer']},
        loadChildren: ()=> import('../views/projects/projects.module').then(m=>m.ProjectsModule)
    },
    {
        path:'clientList',
        canActivateChild: [AuthGuard],
        data: {expectedRole: ['Employee','Admin', 'Super Admin']},
        loadChildren: ()=> import('../views/details-list/details-list.module').then(m=>m.DetailsListModule)
    },
    {
        path:'importData',
        canActivateChild: [AuthGuard],
        data: {expectedRole: ['Employee','Developer', 'Super Admin']},
        loadChildren: ()=> import('../views/import-data/import-data.module').then(m=>m.ImportDataModule)
    }
];